import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { IModule } from 'redux-state/layout/types.js';

/** Place Holder Module To Be Used for Testing */
function PlaceHolder(props: IModule<IModuleConfig>) {
  return <div style={{ background: 'red', height: '100px', width: '100%' }}>{`Module Name: ${props.config.name}`}</div>;
}

export { PlaceHolder };
